import { useState } from "react";
import { useBooking } from "./booking-context";
import { ResortButton } from "./resort-button";
import { Reveal } from "./reveal";

const fieldClass =
  "w-full border-0 border-b border-border bg-transparent pb-3 pt-1 text-sm text-foreground outline-none transition-colors focus:border-primary";

export function AvailabilityBar() {
  const { openBooking } = useBooking();
  const [form, setForm] = useState({ checkIn: "", checkOut: "", stayType: "Daily", rvLength: "" });

  return (
    <section aria-labelledby="plan-your-stay" className="bg-background pb-6 pt-18 md:pt-24">
      <div className="shell">
        <Reveal>
          <h2 id="plan-your-stay" className="display-md max-w-md">
            Plan Your Stay
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <form
            className="mt-10 grid gap-8 border-t border-border pt-10 md:grid-cols-[repeat(4,minmax(0,1fr))_auto] md:items-end md:gap-6"
            onSubmit={(e) => {
              e.preventDefault();
              openBooking();
            }}
          >
            <div>
              <label htmlFor="checkIn" className="eyebrow mb-3 block text-muted-foreground">
                Check In
              </label>
              <input
                id="checkIn"
                type="date"
                value={form.checkIn}
                onChange={(e) => setForm({ ...form, checkIn: e.target.value })}
                className={fieldClass}
              />
            </div>
            <div>
              <label htmlFor="checkOut" className="eyebrow mb-3 block text-muted-foreground">
                Check Out
              </label>
              <input
                id="checkOut"
                type="date"
                value={form.checkOut}
                onChange={(e) => setForm({ ...form, checkOut: e.target.value })}
                className={fieldClass}
              />
            </div>
            <div>
              <label htmlFor="stayType" className="eyebrow mb-3 block text-muted-foreground">
                Stay Type
              </label>
              <select
                id="stayType"
                value={form.stayType}
                onChange={(e) => setForm({ ...form, stayType: e.target.value })}
                className={fieldClass}
              >
                <option>Daily</option>
                <option>Weekly</option>
                <option>Monthly</option>
              </select>
            </div>
            <div>
              <label htmlFor="rvLength" className="eyebrow mb-3 block text-muted-foreground">
                RV Length
              </label>
              <input
                id="rvLength"
                type="number"
                min={10}
                max={70}
                placeholder="42 ft"
                value={form.rvLength}
                onChange={(e) => setForm({ ...form, rvLength: e.target.value })}
                className={fieldClass}
              />
            </div>
            <ResortButton type="submit" variant="solid" className="w-full md:w-auto">
              Check Availability
            </ResortButton>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
